// Partner With Us
export const PARTNER_WITH_US_TITLE = 'Partner With Us';
export const PARTNER_WITH_US_DESCRIPTION = 'Please fill your details below';

export const SUBMIT = 'Submit';

export const firstNamePartner = 'firstNamePartner';
export const firstName = 'firstName';
export const firstNameRequired = 'Please Enter First Name';
export const firstNamePlaceholder = 'First Name';

export const lastNamePartner = 'lastNamePartner';
export const lastName = 'lastName';
export const lastNamePlaceholder = 'Last Name';
export const lastNameRequired = 'Please Enter Last Name';

export const phonePartner = 'phonePartner';
export const phone = 'phone';
export const phoneRequired = 'Please Enter Your Phone Number';
export const phonePattern = {
  value: /^[0-9]{10}$/,
  message: 'Please Enter a valid Phone Number',
};
export const phonePlaceholder = 'Phone';

export const emailPartner = 'emailPartner';
export const email = 'email';
export const emailRequired = 'Please Enter Email';
export const emailValidRequired = 'Please Enter a Valid Email';
export const emailPattern = {
  value:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  message: emailValidRequired,
};
export const emailPlaceholder = 'Email';

export const companyPartner = 'companyPartner';
export const company = 'company';
export const companyRequired = 'Please Enter Name of Your Company';
export const companyPlaceholder = 'Company';

export const PARTNER_WITH_US_FORM = [
  {
    id: firstNamePartner,
    name: firstName,
    required: firstNameRequired,
    placeholder: firstNamePlaceholder,
  },
  {
    id: lastNamePartner,
    name: lastName,
    required: lastNameRequired,
    placeholder: lastNamePlaceholder,
  },
  {
    id: phonePartner,
    name: phone,
    required: phoneRequired,
    pattern: phonePattern,
    placeholder: phonePlaceholder,
  },
  {
    id: emailPartner,
    name: email,
    required: emailRequired,
    pattern: emailPattern,
    placeholder: emailPlaceholder,
  },
  {
    id: companyPartner,
    name: company,
    required: companyRequired,
    placeholder: companyPlaceholder,
  },
];

export const SCHEDULE_DATA = 'Scheduled Updates for Auto Rates and Mortgage Rates';

// Part with Us Submitted
export const PARTNER_WITH_US_SUBMITTED_HEADER = 'We look forward to working with you!';
export const SUCCESSFUL_MESSAGE = 'Your message was sent successfully.';
export const FOUNDER_DIRECTLY =
  'If you have any further inquiries, please do not hesitate to reach out to the Founder directly.';

export const PARTNER_PORTAL_SECTION_LIST = [
  {
    title: '1. Features Settings Section',
    subheader: () => (
      <>
        <div className="partner-portal-feature-settings-wrapper">
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            Marketing Campaign Email Feature Settings{' '}
          </li>
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            Data Metrics Dashboard Settings
          </li>
          <li className="partner-portal-feature-settings-list-item"> High Risk Loans Section</li>
          <li className="partner-portal-feature-settings-last-list-item">
            {' '}
            Notifications Settings
          </li>
        </div>
      </>
    ),
  },
  {
    title: '2. Dashboard Metrics Section',
    subheader: () => (
      <>
        <div className="partner-portal-feature-settings-wrapper">
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            Marketing Email Campaign Metrics{' '}
          </li>
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            User Engagement and Conversions Metrics
          </li>
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            Ads Source Engagement and Conversion Metrics
          </li>
          <li className="partner-portal-feature-settings-last-list-item">
            {' '}
            A/B Test Metrics Results
          </li>
        </div>
      </>
    ),
  },
  {
    title: '3. Notification Logs Section',
    subheader: () => (
      <>
        <div className="partner-portal-feature-settings-wrapper">
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            Updates on Consumer Preferences{' '}
          </li>
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            Predictive Data Modeling Offers
          </li>
          <li className="partner-portal-feature-settings-list-item">
            {' '}
            Inquiry regarding Predictive Financing Offers
          </li>
          <li className="partner-portal-feature-settings-last-list-item">
            Notification Triggers of High Risk Loan Sales
          </li>
        </div>
      </>
    ),
  },
];

export const PARTNER_SUPPORT_AND_COLLABORATION_SECTION_LIST = [
  {
    title: '1. Advanced Data Insights',
    subheader: () => (
      <>
        <div className="partner-support-collaboration-wrapper">
          <li className="partner-support-collaboration-list-item">
            Market Insights from Marketing Email Campaigns{' '}
          </li>

          <div style={{ marginLeft: '20px' }}>
            <li className="partner-support-collaboration-list-item">
              Detailed breakdown of the conversion rates across the marketing campaign{' '}
            </li>
            <li className="partner-support-collaboration-list-item">
              Revenue per email marketing campaign delivered and demographic breakdowns{' '}
            </li>
          </div>
          <li className="partner-support-collaboration-list-item">
            Market Insights From User Engagement and Conversions Off Ads Source{' '}
          </li>
          <div style={{ marginLeft: '20px' }}>
            <li className="partner-support-collaboration-list-item">
              Conversion Action Report - track conversion events, revenue conversion value{' '}
            </li>
            <li className="partner-support-collaboration-list-item">
              Audience Performance Report - metrics segmented by audience, demographics{' '}
            </li>
          </div>
        </div>
      </>
    ),
  },
  {
    title: '2. User Behavioral Metrics',
    subheader: () => (
      <>
        <div className="partner-support-collaboration-wrapper">
          <li className="partner-support-collaboration-list-item">
            Conversions and User Engagement Across Different Cohorts, Demographics, and Regions{' '}
          </li>
          <div style={{ marginLeft: '20px' }}>
            <li className="partner-support-collaboration-list-item">
              In-Depth Breakdown of the Analytics with additional Sessions, Funnels and Funnel Steps
              across the CashClever Platform{' '}
            </li>
          </div>
          <li className="partner-support-collaboration-list-item">
            In-Depth Analysis Of Various Metrics And Conversions From A/B Tests{' '}
          </li>
          <div style={{ marginLeft: '20px' }}>
            <li className="partner-support-collaboration-list-item">
              Detailed reports of A/B Tests across the different user flows and products{' '}
            </li>
          </div>
        </div>
      </>
    ),
  },
  {
    title: '3. Publish Blog Contents',
    subheader: () => (
      <>
        <div className="partner-support-collaboration-wrapper">
          <li className="partner-support-collaboration-list-item">
            {' '}
            Write, Edit and Publish Blogs{' '}
          </li>
          <li className="partner-support-collaboration-last-list-item">
            {' '}
            Performance Metrics Available{' '}
          </li>
        </div>
      </>
    ),
  },
  {
    title: '4. Custom Enhancement Features',
    subheader: () => (
      <>
        <div className="partner-support-collaboration-wrapper">
          <li className="partner-support-collaboration-last-list-item">
            Add / Modify Features On The PartnerPortal
          </li>
        </div>
      </>
    ),
  },
  {
    title: '5. Support And Collaboration',
    subheader: () => (
      <>
        <div className="partner-support-collaboration-wrapper">
          <li className="partner-support-collaboration-list-item"> Data and Rates Transfers </li>
          <li className="partner-support-collaboration-last-list-item">
            {' '}
            On-Call Engineering Support{' '}
          </li>
        </div>
      </>
    ),
  },
];

export const PARTNERSHIP_TIERS = {
  FREE_TRIAL: {
    // [SCHEDULE_DATA]: '(Once A Month)',
    PartnerHub: {
      PartnerHub_Access: '',
      Admins: [''],
      PartnerHub_Dashboard: {
        'Email Marketing Campaigns': [
          {
            TEXT: '10 Marketing Email Campaigns',
            LIST: ['5k recipients on each campaign', 'Email UI templates available'],
          },
          {
            TEXT: 'Features For Specific Categories Of Email Marketing Campaigns',
            LIST: [
              'Based on Auto Financing Rates Filter - Year of Vehicle, Loan Term, Vehicle Amount, Loan Amount, Down Payment, Trade Ins etc',
              'Based on Mortgage Financing Rates Filter - Occupancy Type. Property Type, Mortgage Term, Loan Amount, Down Payment etc',
              'Based on Broad User Categories - Age Range, Occupations, Geographic Locations, etc',
            ],
          },
        ],
        'Data Analytics Metrics': [
          {
            TEXT: 'Google Ads Metrics',
            LIST: [
              'Breakdown Metrics between Ad Groups under the Ads Campaign for Lender',
              'Area Source Breakdown For The Ads',
              'Demographic Age Breakdown',
              'Median Household Income Breakdown',
              'Search Term Results Breakdown',
            ],
          },
          {
            TEXT: 'Marketing Email Campaign Metrics',
            LIST: ['Delivery Rate, Bounce Rate, Unique Open Rate, Unique Click Rate'],
          },
          {
            TEXT: 'Auto Rates Filter User Engagement Metrics',
            LIST: [
              'Source of Users',
              'Number of Make / Model / Years / Mileage / Estimate Vehicle Amount',
              'Group By Location',
            ],
          },
          {
            TEXT: 'Auto Rates Filter Group By Location',
            LIST: [
              'Conversion Percentage and Total Conversions / Submissions',
              'Down Payments (Including Trade Ins)',
              'Loan Amounts',
              'Loan Terms',
              'Monthly Payment Estimates',
            ],
          },
          {
            TEXT: 'Mortgage Rates Filter User Engagement Metrics',
            LIST: ['Source of Users', 'Group By Location'],
          },
          {
            TEXT: 'Mortgage Rates Filter Group By Location',
            LIST: [
              'Conversion Percentage and Total Conversions / Submissions',
              'Number of Occupancy Types, and Property Types, Property Estimate Amounts',
              'Down Payments',
              'Loan Amounts',
              'Mortgage Loan Terms',
              'Monthly Payment Estimates',
              'Mortgage Rates Results',
            ],
          },
        ],
      },
    },
  },
  BRONZE_TIER: {
    [SCHEDULE_DATA]: '(Bi-Weekly)',
    PartnerHub: {
      PartnerHub_Access: '20 Employees',
      Admins: ['2 Super Admins', '4 Admins'],
      PartnerHub_Dashboard: {
        'Email Marketing Campaigns': [
          {
            TEXT: '10 Concurrent Marketing Email Campaigns Able To Be Scheduled',
            LIST: [
              '5k recipients on each campaign',
              'Additional recipients available at additional cost',
              'Email UI templates available',
              'Customizations available at additional cost',
            ],
          },
          {
            TEXT: 'Features For Specific Categories Of Email Marketing Campaigns',
            LIST: [
              'Based on Auto Financing Rates Filter - Year of Vehicle, Loan Term, Vehicle Amount, Loan Amount, Down Payment, Trade Ins etc',
              'Based on Mortgage Financing Rates Filter - Occupancy Type. Property Type, Mortgage Term, Loan Amount, Down Payment etc',
              'Based on Broad User Categories - Age Range, Occupations, Geographic Locations, etc',
            ],
          },
        ],
        'Data Analytics Metrics': [
          {
            TEXT: 'Detailed Analysis Of The Analytics Metrics',
            LIST: [
              'Daily, Weekly, Monthly User Engagement Metrics',
              'Historical Sessions, Funnels with Funnel-Steps',
              '10 Manual Print, Email, Download A Month Included',
              'Extra Charge For Additional Ones',
            ],
          },
          {
            TEXT: 'Email Marketing Campaign Metrics',
            LIST: ['Open Rate, Click Rate, Bounce Rate, and Deliverability Rate'],
          },
        ],
      },
    },
  },
  SILVER_TIER: {
    [SCHEDULE_DATA]: '(Daily)',
    PartnerHub: {
      PartnerHub_Access: '100 Employees',
      Admins: ['5 Super Admins', '10 Admins'],
      PartnerHub_Dashboard: {
        'Email Marketing Campaigns': [
          {
            TEXT: '10 Concurrent Marketing Email Campaigns Able To Be Scheduled',
            LIST: [
              '10k recipients on each marketing campaign',
              'Additional recipients available at additional cost',
              'Email UI Templates Available',
              'Customizations available at additional cost',
            ],
          },
          {
            TEXT: 'Features For Specific Categories Of Email Marketing Campaigns',
            LIST: [
              'Based on Auto Financing Rates Filter - Year of Vehicle, Loan Term, Vehicle Amount, Loan Amount, Down Payment, Trade Ins etc',
              'Based on Mortgage Financing Rates Filter - Occupancy Type. Property Type, Mortgage Term, Loan Amount, Down Payment etc',
              'Based on Broad User Categories - Age Range, Occupations, Geographic Locations, etc',
            ],
          },
          {
            TEXT: 'More In Depth Breakdown And Optionalities For Specific Categories Of Email Campaigns',
            LIST: [
              'Different email marketing UI for the same category campaign for different demographic of consumers based on occupations and age ranges',
              'Send Email Marketing Campaigns based on Auto Financing Predictive Modeling Offers for Users',
              'Send Email Marketing Campaigns based on Mortgage Financing Predictive Modeling Offers for Users',
            ],
          },
        ],
        'Data Analytics Metrics': [
          {
            TEXT: 'Detailed Analysis Of The Analytics Metrics',
            LIST: [
              'Daily, Weekly, Monthly User Engagement Metrics',
              'With More Historical Sessions, more Funnels with Funnel-Steps',
              'More In Depth Breakdown of the Analytics with additional Sessions, Funnels and Funnel Steps across more areas of the CashClever Platform',
              '100 Manual Print, Email, Download A Month Included',
              'Extra Charge For Additional Ones',
            ],
          },
          {
            TEXT: 'Additional A/B Test Metrics Results',
            LIST: [
              'Detailed reports of A/B Tests across the different user flows and products',
              'Analysis and breakdown of results on key funnels',
            ],
          },
          {
            TEXT: 'Email Marketing Campaign Metrics',
            LIST: [
              'Open Rate, Click Rate, Bounce Rate, Deliverability Rate, and Conversion Rate',
              'Detailed breakdown of the conversion rates across the marketing campaigns',
            ],
          },
        ],
        'Notification Logs Section': [
          {
            TEXT: 'Notification Of Consumers Updating User Preference Settings',
            LIST: [
              'Receive notifications when member users update their user setting preferences',
              "Notifications across all aspects for a consumer's preference settings",
            ],
          },
          {
            TEXT: 'Predictive Data Modeling Offers Received By Consumers',
            LIST: [
              'Receive notifications when member users receive offers for Predictive Data Modeling (Auto and Mortgages)',
            ],
          },
          'Notification Triggers When A Lender Is Selling A High Risk Loan After 7 Days',
        ],
        'High Risk Loan Section': [
          'Add, Modify, Remove High Risk Loans To Sell',
          'View And Purchase High Risk Loans Of Other Lenders After 7 Days',
        ],
      },
    },
  },

  GOLD_TIER: {
    [SCHEDULE_DATA]: '(Daily)',

    PartnerHub: {
      PartnerHub_Access: '500 Employees',
      Admins: ['10 Super Admins', '50 Admins'],
      PartnerHub_Dashboard: {
        'Email Marketing Campaigns': [
          {
            TEXT: '100 Different Marketing Email Campaigns Able To Be Scheduled',
            LIST: [
              '100k recipients on each email',
              'Additional recipients available at additional cost',
              'Email UI Templates Available',
              'Customizations available at additional cost',
            ],
          },
          {
            TEXT: 'Features For Specific Categories Of Email Marketing Campaigns',
            LIST: [
              'Based on Auto Financing Rates Filter - Year of Vehicle, Loan Term, Vehicle Amount, Loan Amount, Down Payment, Trade Ins etc',
              'Based on Mortgage Financing Rates Filter - Occupancy Type. Property Type, Mortgage Term, Loan Amount, Down Payment etc',
              'Based on Broad User Categories - Age Range, Occupations, Geographic Locations, etc',
            ],
          },
          {
            TEXT: 'More In Depth Breakdown And Optionalities For Specific Categories Of Email Campaigns',
            LIST: [
              'Different email marketing UI for the same category campaign for different demographic of consumers',
              'Send Email Marketing Campaigns based on Auto Financing Predictive Modeling Offers for Users',
              'Send Email Marketing Campaigns based on Mortgage Financing Predictive Modeling Offers for Users',
              "Based on additional User Settings of consumers' current auto financed loans to refinance",
              "Based on additional User Settings of consumers' current mortgage financed loans to refinance",
            ],
          },
          {
            TEXT: 'Optionalities Available Regarding Additional Products / Services And Blog Contents',
            LIST: [
              'Promote other products and services along with Auto Loans and Mortgages',
              'Promote blogs and other news feed reads to gain further visibility on products and services',
            ],
          },
        ],
        'Data Analytics Metrics': [
          {
            TEXT: 'Detailed Analysis Of The Analytics Metrics',
            LIST: [
              'Daily, Weekly, Monthly User Engagement Metrics',
              'With More Historical Sessions, more Funnels with Funnel-Steps',
              'More In Depth Breakdown of the Analytics with additional Sessions, Funnels and Funnel Steps across more areas of the CashClever Platform',
              '1000 Manual Print, Email, Download A Month Included',
              'Extra Charge For Additional Ones',
            ],
          },
          {
            TEXT: 'Additional A/B Test Metrics Results',
            LIST: [
              'Detailed reports of A/B Tests across the different user flows and products',
              'Analysis and breakdown of results on key funnels',
              'Analytics insights on revenue per conversion rates',
            ],
          },
          {
            TEXT: 'Ads Engagement And Conversion Metrics',
            LIST: [
              'Campaign Performance Reports - Google Ads',
              'Campaign Performance Reports - impressions, clicks, CTR, cost, conversions, ROAS',
              'Search Term Reports - actual search terms, triggering ads',
              'Ad Group Performance Report - metrics broken down at the ad group level',
              'Ad Performance Report - individual ad metrics: CTR, CPC, conversions',
            ],
          },
          {
            TEXT: 'Email Marketing Campaign Metrics',
            LIST: [
              'Open Rate, Click Rate, Bounce Rate, Deliverability Rate, and Conversion Rate',
              'Detailed breakdown of the conversion rates across the marketing campaigns',
              'Engagement over time (Read Depth / Active Rate)',
              'Email forwarding / sharing rate',
              'More detailed breakdown of analytic insights',
            ],
          },
          {
            TEXT: 'Blogs Content Analytic Insights',
            LIST: [
              'Engagement over time (Read Time / Conversion Rate)',
              'In-depth funnel analytics and conversions based on blog content, product / service and engagement',
            ],
          },
        ],
        'Notification Logs Section': [
          {
            TEXT: 'Notification Of Consumers Updating User Preference Settings',
            LIST: [
              'Receive notifications when member users update their user setting preferences',
              // 'Receive notifications when eligible users update their user setting preferences',
              "Notifications across all aspects for a consumer's preference settings",
              'Notifications when the member has updates with their co borrowers and other connected parties',
            ],
          },
          {
            TEXT: 'Predictive Data Modeling Offers Received By Consumers',
            LIST: [
              'Receive notifications when member users receive offers for Predictive Data Modeling (Auto and Mortgages)',
              'Higher preferential priority on listing offers for consumers who qualified on the Predictive Data Modeling',
              'Increase efficiency and accuracy of the predictive data modeling offers',
            ],
          },
          {
            TEXT: 'Consumers Requesting The Specific Lender To Contact Them Inquiring More About The Loan Information',
            LIST: [
              'Receive notifications when a consumer requests additional information and inquires more after receiving the predictive loan offer',
              'Improve efforts to close the funnel loan conversions',
            ],
          },
          'Notification Triggers When A Lender Is Selling A High Risk Loan After 5 Days',
          {
            TEXT: 'Designated Slack Channel For Additional Notifications',
            LIST: [
              'Notifications from data migration of rates, and other data metrics',
              'On going chat assistance available',
            ],
          },
        ],
        'High Risk Loan Section': [
          'Add, Modify, Remove High Risk Loans To Sell',
          'View And Purchase The High Risk Loans Of Other Lenders After 5 Days Lender Uploads The Loan',
        ],
        'Blogs Access': ['Add, Modify And Delete Blogs'],
      },
    },
  },

  DIAMOND_TIER: {
    [SCHEDULE_DATA]: '(Daily)',

    PartnerHub: {
      PartnerHub_Access: '1000 Employees',
      Admins: ['20 Super Admins', '100 Admins'],
      PartnerHub_Dashboard: {
        'Email Marketing Campaigns': [
          {
            TEXT: 'Unlimited Different Marketing Email Campaigns Able To Be Scheduled',
            LIST: [
              '200k recipients on each email',
              'Additional recipients available at additional cost',
              'Email UI Templates Available',
              'Customizations available at additional cost',
            ],
          },
          {
            TEXT: 'Features For Specific Categories Of Email Marketing Campaigns',
            LIST: [
              'Based on Auto Financing Rates Filter - Year of Vehicle, Loan Term, Vehicle Amount, Loan Amount, Down Payment, Trade Ins etc',
              'Based on Mortgage Financing Rates Filter - Occupancy Type. Property Type, Mortgage Term, Loan Amount, Down Payment etc',
              'Based on Broad User Categories - Age Range, Occupations, Geographic Locations, etc',
            ],
          },
          {
            TEXT: 'More In Depth Breakdown And Optionalities For Specific Categories Of Email Campaigns',
            LIST: [
              'Different email marketing UI for the same category campaign for different demographic of consumers',
              'Send Email Marketing Campaigns based on Auto Financing Predictive Modeling Offers for Users',
              'Send Email Marketing Campaigns based on Mortgage Financing Predictive Modeling Offers for Users',
              "Based on additional User Settings of consumers' current auto financed loans to refinance",
              "Based on additional User Settings of consumers' current mortgage financed loans to refinance",
            ],
          },
          {
            TEXT: 'Optionalities Available Regarding Additional Products / Services And Blog Contents',
            LIST: [
              'Promote other products and services along with Auto Loans and Mortgages',
              'Promote blogs and other news feed reads to gain further visibility on products and services',
            ],
          },
          {
            TEXT: 'Customizeable Marketing Email Campaign Schedules Available',
            LIST: ['Inquire to learn more'],
          },
        ],
        'Data Analytics Metrics': [
          {
            TEXT: 'Detailed Analysis Of The Analytics Metrics',
            LIST: [
              'Daily, Weekly, Monthly User Engagement Metrics',
              'With More Historical Sessions, more Funnels with Funnel-Steps',
              'More In Depth Breakdown of the Analytics with additional Sessions, Funnels and Funnel Steps across more areas of the CashClever Platform',
              '1000 Manual Print, Email, Download A Month Included',
              'Extra Charge For Additional Ones',
            ],
          },
          {
            TEXT: 'Additional A/B Test Metrics Results',
            LIST: [
              'Detailed reports of A/B Tests across the different user flows and products',
              'Analysis and breakdown of results on key funnels',
              'Analytics insights on revenue per conversion rates',
            ],
          },
          {
            TEXT: 'Ads Engagement And Conversion Metrics',
            LIST: [
              'Campaign Performance Reports - all sources of ads such as Google, Bing, Reddit etc',
              'Campaign Performance Reports - impressions, clicks, CTR, cost, conversions, ROAS',
              'Search Term Reports - actual search terms, triggering ads',
              'Ad Group Performance Report - metrics broken down at the ad group level',
              'Ad Performance Report - individual ad metrics: CTR, CPC, conversions',
              'Audience Performance Report - metrics segmented by audience, demographics',
              'Geo Performance Report - performance by geographic location',
              'Conversion Action Report - track conversion events, revenue conversion value',
            ],
          },
          {
            TEXT: 'Email Marketing Campaign Metrics',
            LIST: [
              'Open Rate, Click Rate, Bounce Rate, Deliverability Rate, and Conversion Rate',
              'Detailed breakdown of the conversion rates across the marketing campaigns',
              'Engagement over time (Read Depth / Active Rate)',
              'Email forwarding / sharing rate',
              'More detailed breakdown of analytic insights',
              'Revenue per email marketing campaign delivered and demographic breakdowns',
            ],
          },
          {
            TEXT: 'Additional Metrics From Email Marketing Campaigns and Customizations',
            LIST: [
              'Email Marketing Campaign Customizations enabling additional customization metrics that can be tracked for lenders',
              'Email Marketing Campaigns delivered by CashClever',
              'Email Marketing Campaign return on investments',
            ],
          },
          {
            TEXT: 'Blogs Content Analytic Insights',
            LIST: [
              'Engagement over time (Read Time / Conversion Rate)',
              'In-depth funnel analytics and conversions based on blog content, product / service and engagement',
            ],
          },
          {
            TEXT: 'Additional Metrics Available From Loan Originations',
            LIST: ['End to End flow of origin, conversions, offer and funded loan'],
          },
        ],
        'Notification Logs Section': [
          {
            TEXT: 'Notification Of Consumers Updating User Preference Settings',
            LIST: [
              'Receive notifications when member users update their user setting preferences',
              // 'Receive notifications when eligible users update their user setting preferences',
              "Notifications across all aspects for a consumer's preference settings",
              'Notifications when the member has updates with their co borrowers and other connected parties',
            ],
          },
          {
            TEXT: 'Predictive Data Modeling Offers Received By Consumers',
            LIST: [
              'Receive notifications when member users receive offers for Predictive Data Modeling (Auto and Mortgages)',
              'Higher preferential priority on listing offers for consumers who qualified on the Predictive Data Modeling',
              'Increase efficiency and accuracy of the predictive data modeling offers',
            ],
          },
          {
            TEXT: 'Consumers Requesting The Specific Lender To Contact Them Inquiring More About The Loan Information',
            LIST: [
              'Receive notifications when a consumer requests additional information and inquires more after receiving the predictive loan offer',
              'Convert the funnel to loan offers and funded loans',
            ],
          },
          'Notification Triggers When A Lender Is Selling A High Risk Loan After 2 Days',
          {
            TEXT: 'Designated Slack Channel For Additional Notifications',
            LIST: [
              'Notifications from data migration of rates, and other data metrics',
              'On going chat assistance available',
            ],
          },
        ],
        'High Risk Loan Section': [
          {
            TEXT: 'Add, Modify, Remove High Risk Loans To Sell',
            LIST: ['Higher priority loan sales can be available for other lenders sooner'],
          },
          'View And Purchase The High Risk Loans Of Other Lenders After 2 Days Lender Uploads The Loan',
        ],
        'Blogs Access': ['Add, Modify And Delete Blogs'],
        'Diamond Member Specials': [
          {
            TEXT: 'Large Custom Enhancement Development Work Available',
            LIST: [
              'Customizations of schedule run deck emails',
              'Customizations of the UI Design for the PartnerPortal',
              'Customizations to run specifically tailored A/B Tests',
              'Additional other customizations available upon discussions and SOWs',
            ],
          },
          {
            TEXT: 'Loan Origination Integrations',
            LIST: [
              'Integrate with CashClever to provide Auto Loans and Mortgages for consumers',
              'Provide Auto Loans and have access to all the Auto Marketplace Tech Platforms CashClever will be integrating with',
              'Provide Mortgages and have access to all the Real Estate Marketplace Tech Platforms CashClever will be integrating with',
            ],
          },
          {
            TEXT: 'Largest Engineering Support Services Provided',
            LIST: [
              'Fastest SLA turnaround',
              'On call support',
              'Designated highest technical point of contact',
            ],
          },
        ],
      },

      SPECIFICS: [
        {
          TEXT: 'Primarily Reserved For Large Custom Enhancement Development',
          LIST: [
            'Notifications from data migration of rates, and other data metrics',
            'On going chat assistance available',
          ],
        },
        'Future Loan Origination Members',
        'Largest Engineering Support Services Provided',
      ],
    },
  },
};

export const FREE = 'Free Trial';
export const FREE_TRIAL = 'FREE_TRIAL';

export const BRONZE = 'Bronze Tier';
export const BRONZE_TIER = 'BRONZE_TIER';

export const SILVER = 'Silver Tier';
export const SILVER_TIER = 'SILVER_TIER';

export const GOLD = 'Gold Tier';
export const GOLD_TIER = 'GOLD_TIER';

export const DIAMOND = 'Diamond Tier';
export const DIAMOND_TIER = 'DIAMOND_TIER';

export const PARTNERSHIP_TIER_LABELS = [
  { title: FREE, name: FREE_TRIAL },
  { title: BRONZE, name: BRONZE_TIER },
  { title: SILVER, name: SILVER_TIER },
  { title: GOLD, name: GOLD_TIER },
  { title: DIAMOND, name: DIAMOND_TIER },
];

export const EMPOWERING_LENDERS_WITH_DATA_DRIVEN_INSIGHTS =
  'Empowering Lenders with Data-Driven Insights';
export const JOIN_OUR_NETWORK_OF_LENDERS_TO_ACCESS =
  'Join our network of lenders to access powerful analytics to make informed decisions';
export const SCHEDULE_A_DEMO = 'Request Free Trial';
export const VIEW_PDF = 'View Partnership PDF';

export const THE_PARTNER_PORTAL = 'The PartnerPortal';
export const KEY_FUNCTIONALITY_FEATURE_SECTIONS = 'Key Functionality Feature Sections';

export const HANDS_ON_SUPPORT_AND_COLLABORATION = 'Hands-On Support and Collaboration';
export const HOW_WE_CAN_WORK_TOGETHER_AND_IMPROVE = 'How We Can Work Together And Improve';

export const PARTNERSHIP_TIERS_HEADER = 'Partnership Tiers';
export const STAY_UP_DATE =
  'Stay up to date with consumer trends to refine and iterate on latest market trends for your products and services';

export const PARTNER_PORTAL_HEADER = 'Partner Portal';
export const PARTNER_PORTAL = 'PartnerPortal';
export const ADMINS = 'Admins';

export const PARTNER_PORTAL_DASHBOARD_FEATURES = 'Partner Portal Dashboard Features';
